// src/pages/CompletionCertificate.jsx
import React, { useRef } from "react";

export default function CompletionCertificate() {
  const ref = useRef(null);

  const handlePrint = () => {
    window.print(); // Save as PDF from the browser's print dialog
  };

  return (
    <div className="min-h-screen bg-[#F5F7FB] text-[#121317] flex flex-col items-center">
      <div className="w-full max-w-4xl px-4 py-6 print:px-0">
        <h1 className="text-3xl font-extrabold mb-4 print:hidden">
          Treblin Town Certificate
        </h1>

        <div
          ref={ref}
          className="bg-white shadow-lg rounded-2xl border border-black/10 p-6 md:p-10 print:shadow-none print:border-0"
          style={{ WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}
        >
          {/* CERT BODY */}
          <div className="text-center">
            <div className="text-2xl font-bold">Certificate of Mastery</div>
            <div className="mt-2 text-sm opacity-70">
              Treble Town — Piano for Everyone
            </div>

            <div className="my-6 h-[1px] w-full bg-black/10" />

            <p className="text-lg">
              This certifies that{" "}
              <span className="font-semibold underline">[Student Name]</span>{" "}
              has bravely completed all 10 chapters, mastered the melodies, and
              <span className="font-semibold"> defeated Doron</span>, the dragon of Treble Town.
            </p>

            <div className="my-6 h-[1px] w-full bg-black/10" />

            {/* Statue image block */}
            <div className="mx-auto w-full max-w-md aspect-square bg-[#E9EEF5] rounded-2xl flex items-center justify-center overflow-hidden">
              <img
                src="/images/doron-statue.png"
                alt="Stone statue of Doron"
                className="w-[92%] h-[92%] object-contain print:w-full print:h-auto"
                draggable="false"
              />
            </div>

            <div className="my-6 h-[1px] w-full bg-black/10" />

            <div className="flex items-center justify-between mt-6 text-sm">
              <div>
                <div className="font-semibold">Nishat Chadha</div>
                <div className="opacity-70">Creator, Treble Town</div>
              </div>
              <div className="opacity-70">Date: ____________</div>
            </div>
          </div>
        </div>

        <div className="mt-4 flex gap-3 no-print">
          <button
            onClick={handlePrint}
            className="px-5 py-3 rounded-xl bg-black text-white font-semibold hover:opacity-90"
          >
            Download as PDF
          </button>
          <a
            href="/victory"
            className="px-5 py-3 rounded-xl border border-black/20 font-semibold hover:bg-black/5"
          >
            Back to Victory
          </a>
        </div>
      </div>
    </div>
  );
}
